(function () {
    'use strict';

    angular
        .module('app')
        .controller('myTrainingSelectActionConfirmModalController', myTrainingSelectActionConfirmModalController);

    function myTrainingSelectActionConfirmModalController($uibModalInstance, $interval, $scope,
        ctmsConfirmTime, loginService, $location, $rootScope, $uibModalStack) {
        var DEFUALT_CONFIRMTIME = 10;
        var vm = this;
        vm.containu = containu;
        //==========
        init();
        //==========

        function init() {
            // console.log("myTrainingSelectActionConfirmModalController,ctmsConfirmTime:", ctmsConfirmTime);
            dataInit();
            logicInit();
        }
        function dataInit() {
            vm.data = {
                ctmsConfirmTime: ctmsConfirmTime || DEFUALT_CONFIRMTIME,//.......倒數計時
            };

        }
        function logicInit() {
            var promise = $interval(function () {
                // console.log("ctmsConfirmTime:",ctmsConfirmTime);
                vm.data.ctmsConfirmTime--;
                if (vm.data.ctmsConfirmTime < 1) {
                    // 移除目前所有 modal 視窗 
                    $uibModalStack.dismissAll();
                    $interval.cancel(promise);
                }
            }, 1000, vm.data.ctmsConfirmTime);


            $scope.$on('$destroy', function () {
                $interval.cancel(promise);
            });

        }

        function containu() {
            $uibModalInstance.close();
        }
    }
})();
